import { endpointWrapper } from './meta.api';

export const getVersionGoogle = () =>
    endpointWrapper({ domain: 'google/version' });
export const getVersionTikTok = () =>
    endpointWrapper({ domain: 'tiktok/version' });
export const getVersionInstagram = () =>
    endpointWrapper({ domain: 'instagram/version' });
export const getVersionPopularity = () =>
    endpointWrapper({ domain: 'popularity/version' });
